import React from 'react';
import { bool, func, shape, string } from 'prop-types';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles(theme => ({
  paper: {
    height: '100%',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: ({ height }) => height,
      width: ({ width }) => width,
    },
  },
}));

const MessageModal = ({ active, children, onClose, width, height }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ width, height });

  return (
    <Dialog
      open={active}
      onClose={onClose}
      PaperProps={{ elevation: 0 }}
      fullScreen={isMobile}
      classes={{ paper: classes.paper }}
    >
      {onClose && (
        <Box width="100%" display="flex" flexDirection="row" justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
      {children}
    </Dialog>
  );
};

MessageModal.propTypes = {
  active: bool,
  children: shape().isRequired,
  onClose: func.isRequired,
  width: string,
  height: string,
};

MessageModal.defaultProps = {
  active: false,
  width: '400px',
  height: '600px',
};

export default MessageModal;
